import { propOr } from 'ramda';
import { useBonusesStore } from '../../store';

const selectActiveBsWithdrawBonus = () => propOr([], 'bsWithdrawBonuses');
export const useActiveBsWithdrawBonus = () => {
  const bsWithdrawBonuses = useBonusesStore(selectActiveBsWithdrawBonus());

  return bsWithdrawBonuses[0];
};
